import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirFaqItem } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirFaqItemsAdapter = createEntityAdapter<JSONApiDataObject<BsdirFaqItem>>({
  selectId: item => item.id
});

export const bsdirFaqItemsSlice = createSlice({
  name: 'bsdirFaqItems',
  initialState: bsdirFaqItemsAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirFaqItem>),
  reducers: {
    bsdirFaqItemsAdded: (state, action) => {
      bsdirFaqItemsAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirFaqItemsSelectors = bsdirFaqItemsAdapter.getSelectors(
  (state: RootState) => state.bsdir.faqItems);
export default bsdirFaqItemsSlice.reducer;
